import HeaderContainers from '../HeaderContainers/HeaderContainers';
import InputPadrao from '../InputPadrao/InputPadrao';
import './FiltroUsuarioContainer.css';
import { FaUser } from "react-icons/fa";
import BotaoCustom from '../BotaoCustom/BotaoCustom';
import { FaSearch, FaPlus } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { IoDocumentTextSharp } from "react-icons/io5";
import InputSelectPadrao from '../InputSelectPadrao/InputSelectPadrao';
import { UsuarioFilterContext } from '../../context/UsuarioFilterContext';
import { useContext, useEffect, useState } from 'react';
import { getSituacaoCadastro } from '../../services/situacaoCadastroService';
import BotaoPadrao from '../BotaoPadrao/BotaoPadrao';
import NotifyUtils from '../../utils/NotifyUtils';
import { useAuth } from '../../services/AuthContext';
import { useTranslation } from 'react-i18next';

function FiltroUsuarioContainer() {

  const { t } =  useTranslation();
  const { user } = useAuth();
  const { handleClear, handleSearch, handleChange, usuarioFilter } = useContext(UsuarioFilterContext);
  const [ resetaFiltroSitCadastro, setResetaFiltroSitCadastro ] = useState(false);

  const limparFiltros = () => {
    NotifyUtils.sucesso(t("retira-filtros"));
    setResetaFiltroSitCadastro(!resetaFiltroSitCadastro);
    handleClear();
  };

  // Função que direciona para a página de cadastro de usuário
  const direcionaParaCadastroUsuario = () => {
    if(!user.podeCadastrarUsuario) {
        NotifyUtils.aviso(t("aviso-cadastro-departamento"));
        return;
    }

    window.location.href = "/cadastrar-usuario";
  }

  const pesquisar = () => {
    handleSearch();
    NotifyUtils.sucesso(t("pesquisa-sucesso"));
  }

  const [situacaoCadastro, setSituacaoCadastro] = useState(null);
  useEffect(() => {
      getSituacaoCadastro().then((situacaoCadastro) => {
          setSituacaoCadastro(situacaoCadastro);
      }).catch((error) => {
          console.error(error);
      });
  }, []);

  let situacoesCadastro = [];
  if (situacaoCadastro !== null) {
      situacoesCadastro = situacaoCadastro;
  } else {
      return <div>Loading...</div>;
  }

  return (
    <div>
        <HeaderContainers texto={t("selecione-filtros")} />

        <div className="container-filtro-usuarios">

          <div className="inputs-principal-filtro-usuario">
            <InputPadrao 
              className={"input-nome-filtro-usuario"}
              inputPara={"nome"}
              titulo={t("nome")}
              icone={<FaUser />}
              placeholder={t("place-holder-nome")}
              obrigatorio={false}
              type={"text"}
              name={"nome"}
              value={usuarioFilter.nome}
              onChange={handleChange}
            />

            <InputPadrao
              className={"input-email-filtro-usuario"}
              titulo={t("email")}
              inputPara={"email"}
              icone={<IoMdMail />}
              placeholder={t("place-holder-email")}
              obrigatorio={false}
              type={"text"}
              name={"email"}
              value={usuarioFilter.email}
              onChange={handleChange}
            />

            <InputPadrao
              className={"input-cpf-filtro-usuario"}
              titulo={t("numero-cpf")}
              inputPara={"cpf"}
              icone={<IoDocumentTextSharp />}
              placeholder={t("place-holder-cpf")}
              obrigatorio={false}
              type={"text"}
              name={"cpf"}
              mask={"cpf"}
              value={usuarioFilter.cpf}
              onChange={handleChange}
            />

            <InputSelectPadrao
              className={"input-situacao-cadastro-filtro-usuario"}
              titulo={t("situacao-cadastro")}
              inputPara={"situacaoCadastro"}
              icone={<IoDocumentTextSharp />}
              obrigatorio={false}
              name={"situacao-cadastro"}
              options={situacoesCadastro}
              value={usuarioFilter.situacaoCadastro}
              onChange={handleChange}
              sendAll={true}
              resetaFiltro={resetaFiltroSitCadastro}
            />
          </div>

          <div className="botoes-filtro-usuarios">
            <BotaoPadrao
              texto={t("botao-limpa-filtros")}
              icone={null}
              acaoDeClicar={limparFiltros}
            />

            <BotaoCustom
                acaoDeClicar={pesquisar}
                icone={<FaSearch />}
                texto={t("botao-pesquisar")}
                cancelar={false}
            />
            
            <BotaoCustom
              acaoDeClicar={direcionaParaCadastroUsuario}
              icone={<FaPlus />}
              texto={t("botao-cadastra-usuario")}
              cancelar={true}
            />
          </div>
        </div>
    </div>
  )
}

export default FiltroUsuarioContainer